import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { ScheduledTasksListPage } from './ScheduledTasksListPage';
import { ScheduledTasksEditPageWrapper } from './ScheduledTasksEditPageWrapper';
// import {fetchTasks} from '../redux';

export function ScheduledTasksPage({ isExpanded, user }) {
  return (
    <Routes>
      <Route
        path="/"
        exact
        element={<ScheduledTasksListPage user={user} isExpanded={isExpanded} />}
      />
      <Route
        path="/add"
        element={<ScheduledTasksEditPageWrapper user={user} isExpanded={isExpanded} />}
      />
      <Route
        path="/edit/:id"
        element={<ScheduledTasksEditPageWrapper user={user} isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

ScheduledTasksPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
  user: propTypes.object.isRequired,
};
